import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';


const ThanksPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 to-white px-4">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="text-green-500 text-6xl mb-4"
        >
          ✅
        </motion.div>

        <h1 className="text-2xl font-bold text-gray-800 mb-2">Thank You for Shopping!</h1>
        <p className="text-gray-600 mb-6">Your order has been successfully placed. <br /> Check  your email for seller details and pick up We appreciate your trust in us and hope to see you again soon!</p>
        {/* Button to Continue */}
        <motion.div whileHover={{ scale: 1.05 }}>
          <Link to="/product" className="inline-block bg-green-600 text-white px-5 py-2 rounded-full shadow-md hover:bg-green-700 transition">
            Continue Shopping
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ThanksPage;
